import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-6adb68ae")
const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", null, " 秒", -1)
const _hoisted_2 = /*#__PURE__*/_createTextVNode("新增 ")
_popScopeId()

import { computed, ref, toRaw } from 'vue'
import UploadSong from './UploadSong.vue'
import { MinusCircleOutlined, PlusOutlined, UpCircleOutlined, DownCircleOutlined } from '@ant-design/icons-vue'
import { message } from 'ant-design-vue'
import { ColorList } from './config'


export default {
  props: {
  visible: {
    type: Boolean,
    default: () => {
      return false
    }
  },
  isEdit: {
    type: Boolean,
    default: () => {
      return false
    }
  },
  value: {
    type: Object,
    default: () => {
      return {}
    }
  },
  aliasConfig: {
    type: Object,
    default: () => {
      return {
        url: 'file_url',
        name: 'file_name',
        md5: 'file_md5',
        size: 'file_size'
      }
    }
  }
},
  emits: ['onOk', 'onEditOk', 'cancel'],
  setup(__props, { emit }) {

const props = __props



const colorList = ColorList
const visibleComputed = computed(() => props.visible)
const isEditComputed = computed(() => props.isEdit)

const current = ref(props.value)

const labelCol = { span: 5 }
const wrapperCol = { span: 17 }

const formRef = ref()

const handleSelectSongOk = info => {
  current.value = { ...toRaw(current.value), ...info }
}

const handleDelete = item => {
  const index = current.value.para_info.indexOf(item)
  const oldCurrent = ref({ ...toRaw(current.value) })
  const list = [...toRaw(oldCurrent.value.para_info)]
  list.splice(index, 1)
  oldCurrent.value.para_info = list
  current.value = oldCurrent.value
}

const handleAddParaInfo = () => {
  if (!current.value.para_info) {
    current.value.para_info = []
  }
  current.value.para_info.push({})
}

const handleMoveItem = (fromIdx, toIdx) => {
  const array = current.value.para_info
  const [minAvailable, maxAvailable] = [0, array.length - 1]
  if (
    fromIdx >= minAvailable &&
    toIdx >= minAvailable &&
    fromIdx <= maxAvailable &&
    toIdx <= maxAvailable
  ) {
    array.splice(
      toIdx,
      1,
      ...array.splice(fromIdx, 1, array[toIdx])
    )
  }
}

const handleCancel = () => {
  emit('cancel')
}

const handleOk = () => {
  const info = ref(toRaw(current.value))
  if (info.value.para_info) {
    for (let i = 0; i < info.value.para_info.length; i++) {
      if (!info.value.para_info[i].name) {
        message.error('分段名称不能为空')
        throw new Error('分段名称不能为空')
      } else if (info.value.para_info[i].start_time === null) {
        message.error('起始点不能为空')
        throw new Error('起始点不能为空')
      } else if (!info.value.para_info[i].color) {
        message.error('颜色不能为空')
        throw new Error('颜色不能为空')
      }
    }
  }
  if (!info.value[props.aliasConfig.name]) {
    message.error('请选择歌曲上传')
    throw new Error('请选择歌曲上传')
  }
  if (isEditComputed.value) {
    emit('onEditOk', info.value)
  } else {
    emit('onOk', info.value)
  }
  handleCancel()
}


return (_ctx, _cache) => {
  const _component_a_form_item = _resolveComponent("a-form-item")
  const _component_a_input = _resolveComponent("a-input")
  const _component_a_col = _resolveComponent("a-col")
  const _component_a_input_number = _resolveComponent("a-input-number")
  const _component_a_tag = _resolveComponent("a-tag")
  const _component_a_select = _resolveComponent("a-select")
  const _component_a_row = _resolveComponent("a-row")
  const _component_a_button = _resolveComponent("a-button")
  const _component_a_form = _resolveComponent("a-form")
  const _component_a_modal = _resolveComponent("a-modal")

  return (_openBlock(), _createBlock(_component_a_modal, {
    title: __props.isEdit ? '编辑配置' : '新增配置',
    visible: _unref(visibleComputed),
    maskClosable: false,
    width: "1000px",
    okText: "确定",
    cancelText: "取消",
    onCancel: handleCancel,
    onOk: handleOk
  }, {
    default: _withCtx(() => [
      _createVNode(_component_a_form, {
        model: current.value,
        "onUpdate:model": _cache[4] || (_cache[4] = $event => (current.value = $event)),
        labelCol: labelCol,
        wrapperCol: wrapperCol
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_form_item, { label: "MP3歌曲" }, {
            default: _withCtx(() => [
              _createVNode(UploadSong, {
                onOk: handleSelectSongOk,
                aliasConfig: props.aliasConfig
              }, null, 8, ["aliasConfig"])
            ]),
            _: 1
          }),
          _createVNode(_component_a_form_item, { label: "歌曲名称" }, {
            default: _withCtx(() => [
              _createVNode(_component_a_input, {
                value: current.value[props.aliasConfig.name],
                "onUpdate:value": _cache[0] || (_cache[0] = $event => (current.value[props.aliasConfig.name] = $event))
              }, null, 8, ["value"])
            ]),
            _: 1
          }),
          _createVNode(_component_a_form_item, { label: "歌曲地址" }, {
            default: _withCtx(() => [
              _createVNode(_component_a_input, {
                value: current.value[props.aliasConfig.url],
                "onUpdate:value": _cache[1] || (_cache[1] = $event => (current.value[props.aliasConfig.url] = $event)),
                disabled: true
              }, null, 8, ["value"])
            ]),
            _: 1
          }),
          _createVNode(_component_a_form_item, { label: "歌曲md5" }, {
            default: _withCtx(() => [
              _createVNode(_component_a_input, {
                value: current.value[props.aliasConfig.md5],
                "onUpdate:value": _cache[2] || (_cache[2] = $event => (current.value[props.aliasConfig.md5] = $event)),
                disabled: true
              }, null, 8, ["value"])
            ]),
            _: 1
          }),
          _createVNode(_component_a_form_item, { label: "歌曲文件大小" }, {
            default: _withCtx(() => [
              _createVNode(_component_a_input, {
                value: current.value[props.aliasConfig.size],
                "onUpdate:value": _cache[3] || (_cache[3] = $event => (current.value[props.aliasConfig.size] = $event)),
                disabled: true
              }, null, 8, ["value"])
            ]),
            _: 1
          }),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(current.value.para_info, (pItem, pIndex) => {
            return (_openBlock(), _createBlock(_component_a_row, {
              size: "small",
              key: pIndex
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_col, {
                  span: 6,
                  offset: 3
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_form_item, {
                      label: "分段名",
                      labelCol: { span: 8 },
                      wrapperCol: { span: 14 },
                      rules: [{ required: true, message: '请输入分段名' }]
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_input, {
                          value: pItem.name,
                          "onUpdate:value": $event => (pItem.name = $event),
                          style: {"width":"100%","margin-right":"10px"}
                        }, null, 8, ["value", "onUpdate:value"])
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1024),
                _createVNode(_component_a_col, { span: 6 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_form_item, {
                      labelCol: { span: 10 },
                      wrapperCol: { span: 12 },
                      label: "分段起始点",
                      rules: [{ required: true, message: '请输入起始点' }]
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_input_number, {
                          value: pItem.start_time,
                          "onUpdate:value": $event => (pItem.start_time = $event),
                          step: 0.1,
                          min: 0
                        }, null, 8, ["value", "onUpdate:value", "step"]),
                        _hoisted_1
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1024),
                _createVNode(_component_a_col, { span: 5 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_form_item, {
                      label: "分段颜色",
                      labelCol: { span: 8 },
                      wrapperCol: { span: 12 },
                      rules: [{ required: true, message: '请选择颜色' }]
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_select, {
                          value: pItem.color,
                          "onUpdate:value": $event => (pItem.color = $event),
                          options: _unref(colorList)
                        }, {
                          option: _withCtx(({ label, tag }) => [
                            _createVNode(_component_a_tag, {
                              style: {"height":"10px"},
                              color: tag
                            }, null, 8, ["color"]),
                            _createTextVNode(" " + _toDisplayString(label), 1)
                          ]),
                          _: 2
                        }, 1032, ["value", "onUpdate:value", "options"])
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1024),
                _createVNode(_unref(UpCircleOutlined), {
                  disabled: pIndex === 0,
                  onClick: $event => (handleMoveItem(pIndex, pIndex - 1)),
                  class: "delete-button"
                }, null, 8, ["disabled", "onClick"]),
                _createVNode(_unref(DownCircleOutlined), {
                  disabled: pIndex === current.value.para_info.length - 1,
                  onClick: $event => (handleMoveItem(pIndex, pIndex + 1)),
                  class: "delete-button"
                }, null, 8, ["disabled", "onClick"]),
                _createVNode(_unref(MinusCircleOutlined), {
                  onClick: $event => (handleDelete(pItem)),
                  class: "delete-button"
                }, null, 8, ["onClick"])
              ]),
              _: 2
            }, 1024))
          }), 128)),
          _createVNode(_component_a_form_item, { wrapperCol: { offset: 5, span: 17 } }, {
            default: _withCtx(() => [
              _createVNode(_component_a_button, {
                style: {"width":"100%"},
                onClick: handleAddParaInfo
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(PlusOutlined)),
                  _hoisted_2
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model"])
    ]),
    _: 1
  }, 8, ["title", "visible"]))
}
}

}